module.exports = __webpack_public_path__ + "static/media/gear.a48effd5.svg";